<template>
  <g>
    <path
      d="M4.89478 19.0716C4.89478 20.1367 5.74308 21.0002 6.78951 21.0002H17.2106C18.257 21.0002 19.1053 20.1367 19.1053 19.0716V4.92875C19.1053 3.86363 18.257 3.00018 17.2106 3.00018H10.0453C9.68197 3.00018 9.33626 3.1594 9.09644 3.43718L5.20909 7.9397C5.00651 8.17434 4.89478 8.47604 4.89478 8.78841V19.0716Z"
      fill="white"
    />
    <path
      d="M4.89478 19.0716C4.89478 20.1367 5.74308 21.0002 6.78951 21.0002H17.2106C18.257 21.0002 19.1053 20.1367 19.1053 19.0716V4.92875C19.1053 3.86363 18.257 3.00018 17.2106 3.00018H10.0453C9.68197 3.00018 9.33626 3.1594 9.09644 3.43718L5.20909 7.9397C5.00651 8.17434 4.89478 8.47604 4.89478 8.78841V19.0716Z"
      fill="url(#paint0_linear_939_1110)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.39478 19.0716C4.39478 20.4045 5.45863 21.5002 6.78951 21.5002H17.2106C18.5415 21.5002 19.6053 20.4045 19.6053 19.0716V4.92875C19.6053 3.59587 18.5415 2.50018 17.2106 2.50018H10.0453C9.53495 2.50018 9.05167 2.72392 8.71797 3.11043L4.83063 7.61294C4.54898 7.93916 4.39478 8.35708 4.39478 8.78841V19.0716ZM6.78951 20.5002C6.02753 20.5002 5.39478 19.869 5.39478 19.0716V8.78841C5.39478 8.595 5.46403 8.40952 5.58755 8.26645L9.4749 3.76393C9.62085 3.59488 9.82899 3.50018 10.0453 3.50018H17.2106C17.9726 3.50018 18.6053 4.1314 18.6053 4.92875V19.0716C18.6053 19.869 17.9726 20.5002 17.2106 20.5002H6.78951Z"
      fill="#3E7DC0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.36846 7.80371H4.89478V8.80371H8.36846C9.35053 8.80371 10.1316 7.99584 10.1316 7.018V3.00014H9.13162V7.018C9.13162 7.46031 8.78164 7.80371 8.36846 7.80371Z"
      fill="#3E7DC0"
    />
    <g filter="url(#filter0_d_939_1110)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8948 7.50018C11.8948 7.22404 12.1186 7.00018 12.3948 7.00018H14.3948C14.6709 7.00018 14.8948 7.22404 14.8948 7.50018C14.8948 7.77633 14.6709 8.00018 14.3948 8.00018H12.3948C12.1186 8.00018 11.8948 7.77633 11.8948 7.50018Z"
        fill="#3E7DC0"
      />
    </g>
    <g filter="url(#filter1_d_939_1110)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8948 10.5002C11.8948 10.224 12.1186 10.0002 12.3948 10.0002H16.3948C16.6709 10.0002 16.8948 10.224 16.8948 10.5002C16.8948 10.7763 16.6709 11.0002 16.3948 11.0002H12.3948C12.1186 11.0002 11.8948 10.7763 11.8948 10.5002Z"
        fill="#3E7DC0"
      />
    </g>
    <rect y="14.0002" width="24" height="10" rx="2" fill="#3E7DC0" />
    <path
      d="M6.89697 21.5002H5.30078L4.82227 19.3229C4.79948 19.2318 4.76302 19.0506 4.71289 18.7795C4.66504 18.5083 4.62972 18.2816 4.60693 18.0993C4.5887 18.2474 4.55908 18.432 4.51807 18.653C4.47705 18.8718 4.43604 19.0734 4.39502 19.258C4.35628 19.4426 4.19108 20.19 3.89941 21.5002H2.30322L1.06592 16.5031H2.36816L2.91162 19.0085C3.03467 19.5622 3.11898 20.0031 3.16455 20.3312C3.19417 20.0988 3.24658 19.7832 3.32178 19.3845C3.39925 18.9857 3.47103 18.6553 3.53711 18.3932L3.97803 16.5031H5.229L5.65625 18.3932C5.72917 18.6963 5.80322 19.0461 5.87842 19.4426C5.95361 19.8391 6.00374 20.1353 6.02881 20.3312C6.05843 20.0783 6.13932 19.6397 6.27148 19.0153L6.8252 16.5031H8.12744L6.89697 21.5002Z"
      fill="#F8F8F8"
    />
    <path
      d="M11.8394 21.5002L11.5933 20.5637H9.96973L9.7168 21.5002H8.2334L9.86377 16.4826H11.665L13.3159 21.5002H11.8394ZM11.313 19.4562L11.0977 18.6359C11.0475 18.4536 10.986 18.2178 10.9131 17.9284C10.8424 17.639 10.7957 17.4317 10.7729 17.3063C10.7524 17.4225 10.7114 17.614 10.6499 17.8806C10.5907 18.1472 10.4574 18.6724 10.25 19.4562H11.313Z"
      fill="#F8F8F8"
    />
    <path
      d="M17.4858 18.0925C17.4858 18.6507 17.3206 19.0825 16.9902 19.3879C16.6621 19.6909 16.195 19.8425 15.5889 19.8425H15.2095V21.5002H13.8594V16.5031H15.5889C16.2201 16.5031 16.694 16.641 17.0107 16.9167C17.3275 17.1924 17.4858 17.5843 17.4858 18.0925ZM15.2095 18.7419H15.4556C15.6584 18.7419 15.819 18.6849 15.9375 18.571C16.0583 18.4571 16.1187 18.2998 16.1187 18.0993C16.1187 17.7621 15.9318 17.5934 15.5581 17.5934H15.2095V18.7419Z"
      fill="#F8F8F8"
    />
    <path
      d="M22.5308 16.5031V19.5109C22.5308 20.1649 22.3451 20.6719 21.9736 21.0319C21.6045 21.3897 21.0713 21.5685 20.374 21.5685C19.6927 21.5685 19.1686 21.3942 18.8018 21.0456C18.4372 20.697 18.2549 20.1957 18.2549 19.5417V16.5031H19.6118V19.4357C19.6118 19.7889 19.6779 20.0453 19.8101 20.2048C19.9422 20.3643 20.137 20.444 20.3945 20.444C20.6702 20.444 20.8696 20.3654 20.9927 20.2082C21.118 20.0487 21.1807 19.7889 21.1807 19.4289V16.5031H22.5308Z"
      fill="#F8F8F8"
    />
    <defs>
      <filter
        id="filter0_d_939_1110"
        x="7.89478"
        y="7.00018"
        width="11"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1110"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1110"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_939_1110"
        x="7.89478"
        y="10.0002"
        width="13"
        height="9"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_939_1110"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_939_1110"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_939_1110"
        x1="14.8948"
        y1="3.00018"
        x2="14.8948"
        y2="19.5002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#11AAE2" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </g>
</template>
